export default __webpack_public_path__ + "static/media/news1.c1deec84.jpeg";